import React, { useEffect, useState, useRef } from 'react';
import { Input, Select, Spin } from 'antd';
import Attributes from '../../redux/middleware/attributes';
import Delete from '../../assets/images/Delete.svg';
import './style.scss';
// import { handleFloat } from '../../helper/sortData';

type Props = {
  component: any;
  steps: any;
  addinfo: any;
  allergen: any;
  handleallergenCheck: any;
  handleaddionalinfocheck: any;
  handleDeleteStep: any;
  addSteps: any;
  // stepDeleteDialog: any;
  stepIndex: any;
  // handleDeleteDialog: any;
  handleIndex: any;
  handleChangeStep: any;
  calory: any;
  fat: any;
  carb: any;
  protein: any;
  recipeNote: any;
  video: any;
  handlecalory: any;
  handlecarb: any;
  handlefat: any;
  handleprotein: any;
  handleNote: any;
  handlevideo: any;
  prep: any;
  serving: any;
  handleprep: any;
  handleserving: any;
  errorList?: any;
  errorStatus?: boolean;
  handleYeild?: any;
  handleUnit?: any;
  subRecipeUnit?: any;
  yeild?: any;
  unit?: any;
};

type additionalInfo = {
  id: number;
  attribute_name: string;
  status: number;
  created_at: string;
  updated_at: string;
};

const StepThree = (props: Props) => {
  const [spinner, setSpinner] = useState(true);
  const [allergenData, setAlergenData] = useState<any[]>([]);
  const [allergenSelected, setAllergenSelected] = useState<number[]>([]);
  const [attributes, setAttributes] = useState<any[]>([]);

  useEffect(() => {
    fetchAllergen();
    fetchAdditionalData();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (attributes.length && allergenData.length) setSpinner(false);
  }, [allergenData, attributes]);

  const fetchAdditionalData = async () => {
    const data = await Attributes.getAdditionalInfo();
    setAttributes(data?.data);
  };

  const fetchAllergen = async () => {
    const data = await Attributes.getAllergens();
    setAlergenData(data?.data);
  };
  let {
    steps,
    handleallergenCheck,
    handleaddionalinfocheck,
    handleDeleteStep,
    addSteps,
    // stepDeleteDialog,
    // handleDeleteDialog,
    handleIndex,
    handleChangeStep,
    calory,
    fat,
    carb,
    protein,
    recipeNote,
    video,
    handlecalory,
    handlecarb,
    handlefat,
    handleprotein,
    handleNote,
    handlevideo,
    prep,
    serving,
    handleprep,
    handleserving,
    allergen,
    addinfo,
    handleYeild,
    handleUnit,
    subRecipeUnit,
    yeild,
    component,
    unit,
  } = props;
  const { TextArea } = Input;

  const inputRefs = useRef<any>(steps?.map(() => React.createRef()));

  const handleKeyDown = (e: any, index: number) => {
    if (e.key === 'Enter') {
      // Set focus to next text input
      addSteps();
      setTimeout(() => inputRefs.current[index + 1].focus(), 250);
      // inputRefs.current[index + 1].focus();
    }
  };

  const handleCheckboxChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    val: any
  ) => {
    let updatedSelection: any[] = [];
    updatedSelection = allergenSelected.includes(val.id)
      ? allergenSelected.filter((id: any) => id !== val.id)
      : [...allergenSelected, val.id];
    setAllergenSelected(updatedSelection);
    handleallergenCheck(e, val);
  };

  return spinner ? (
    <Spin className="loadIngredient recipeBuilderloaderHeight" />
  ) : (
    <>
      {/* <Modal
        title={<div className="title font">Confirmation</div>}
        centered
        open={stepDeleteDialog}
        onCancel={() => handleDeleteDialog(false)}
        width={480}
        footer={null}
        className="DialogHeight"
      >
        <div className="deleteDialogText">
          Are you sure want to delete “Bacon” ingredient?
        </div>
        <div className="butonGroupDialog">
          <div
            className="wizard-button"
            onClick={() => handleDeleteDialog(false)}
          >
            Cancel
          </div>
          <div className="continue wizard-button" onClick={handleDeleteStep}>
            Continue
          </div>
        </div>
      </Modal> */}
      <div className="step3-head">Cooking instruction</div>
      <div className="wizardDropdownStep3 ">
        <div className="wizardLabel">Steps</div>

        {steps?.length &&
          steps?.map((data: any, index: number) => (
            <div className="stepThreeInput" key={index}>
              <div>{index + 1}</div>
              <Input
                placeholder="Enter field name"
                value={data}
                onChange={(e: any) => handleChangeStep(e.target.value, index)}
                // ref={inputRefs.current[index]}
                ref={(el) => (inputRefs.current[index] = el)}
                // onKeyDown={handleKeyDown}
                onKeyDown={(e: any) => handleKeyDown(e, index)}
                dir="ltr"
              />

              <img
                src={Delete}
                width={15}
                alt=""
                onClick={() => {
                  handleIndex(index);
                  handleDeleteStep(index);
                  // handleDeleteDialog(true);
                }}
              />
            </div>
          ))}
        {/* {errorStatus && (
          <div className="subRecipeErrorMessages">
            {errorList['recipe_type_id'][0]}
          </div>
        )} */}
        <div className="addButton" onClick={addSteps}>
          + Add New
        </div>
      </div>
      <div className="wizardDropdownStep3 stepThreeTextArea">
        <div className="wizardLabel">Recipe Notes</div>

        <TextArea
          rows={4}
          className="text-Area"
          placeholder="Input recipe notes here"
          autoSize={{ minRows: 5, maxRows: 5 }}
          value={recipeNote}
          onChange={(e) => handleNote(e.target.value)}
          dir="ltr"
        />
      </div>
      <div className="step3-head">Advanced</div>
      <div className="wizardDropdownStep3 stepThreeTextArea">
        <div className="wizardLabelAdvance">Training Video (URL)</div>

        <Input
          placeholder="Enter training video"
          value={video}
          onChange={(e) => handlevideo(e.target.value)}
        />
        {/* {errorStatus && (
          <div className="subRecipeErrorMessages">
            {errorList['recipe_type_id'][0]}
          </div>
        )} */}
      </div>
      <div className="PracticeContainer PracticeContainerJustify">
        <div className="wizardDropdownStep3 stepThreeTextArea">
          <div className="PracticeLabel ">Prep Time (Mins)</div>
          <Input
            placeholder="Enter prep time"
            value={prep}
            type="text"
            onChange={(e) => {
              const value = e.target.value;
              // Allow only positive integers
              if (value === '' || /^\d+$/.test(value)) {
                const numValue = value === '' ? 0 : parseInt(value);
                if (value === '' || numValue >= 0) {
                  handleprep(value);
                }
              }
            }}
            style={{ width: '100%' }}
          />
          {/* {errorStatus && (
          <div className="subRecipeErrorMessages">
            {errorList['recipe_type_id'][0]}
          </div>
        )} */}
        </div>
      </div>
      {component == 'R&D Sub Recipe' && (
        <>
          <div className="PracticeContainer PracticeContainerJustify">
            <div className="subContainerPractice stepThreeTextArea">
              <div className="PracticeLabel">
                Yield <span className="sterik">*</span>
              </div>
              <Input
                placeholder="Enter yield"
                value={yeild}
                type="text"
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow up to 3 digits before decimal and 4 digits after decimal (e.g., 352.6354)
                  if (value === '' || /^\d{0,3}(\.?\d{0,4})?$/.test(value)) {
                    handleYeild(value);
                  }
                }}
                style={{ width: '100%' }}
              />
              {/* {errorStatus && (
          <div className="subRecipeErrorMessages">
            {errorList['recipe_type_id'][0]}
          </div>
        )} */}
            </div>

            <div className="subContainerPractice stepThreeTextArea BottomSpacing">
              <div className="PracticeLabel ">
                UOM <span className="sterik">*</span>
              </div>
              <Select
                size={'large'}
                placeholder={'Select UOM'}
                onChange={(e) => handleUnit(e)}
                style={{ width: 300 }}
                value={subRecipeUnit?.unit}
              >
                {unit?.map((data: any, unitIndex: number) => (
                  <Select.Option value={data?.id} key={unitIndex}>
                    {data.unit}
                  </Select.Option>
                ))}
              </Select>
              {/* <Input
            placeholder="Enter prep time"
            value={prep}
            type="number"
            onChange={(e) => handleprep(e.target.value)}
          /> */}
              {/* {errorStatus && (
          <div className="subRecipeErrorMessages">
            {errorList['recipe_type_id'][0]}
          </div>
        )} */}
            </div>
          </div>
        </>
      )}
      <div className="step3-subHead">Nutritions Facts</div>
      <div className="stepThreeSubContainer">
        <div className="stepThreeadditonal">
          <div>Calories</div>
          <div>Carbs</div>
          <div>Fat</div>
          <div className="stepThreeproteinText">Protein</div>
        </div>
        <div className="stepThreeunitContainer">
          <div className="stepThreeborderContainer">
            <div className="stepThreeunitSubContainer">
              <input
                className="gramValue"
                placeholder="0"
                type={'number'}
                value={calory ? Math.round(Number(calory)) : ''}
                onChange={(e) => handlecalory(e.target.value)}
              />
              <div className="unitColor">kcal</div>
            </div>
          </div>
          <div className="borderContainer">
            <div className="unitSubContainer">
              <input
                className="gramValue"
                placeholder="0"
                type={'number'}
                value={carb ? Math.round(Number(carb)) : ''}
                onChange={(e) => handlecarb(e.target.value)}
              />
              <div className="unitColor">g</div>
            </div>
          </div>
          <div className="borderContainer">
            <div className="unitSubContainer">
              <input
                className="gramValue"
                placeholder="0"
                type={'number'}
                value={fat ? Math.round(Number(fat)) : ''}
                onChange={(e) => handlefat(e.target.value)}
              />
              <div className="unitColor">g</div>
            </div>
          </div>
          <div className="borderContainer">
            <div className="unitSubContainer ">
              <input
                className="gramValue"
                placeholder="0"
                type={'number'}
                value={protein ? Math.round(Number(protein)) : ''}
                onChange={(e) => handleprotein(e.target.value)}
              />
              <div className="unitColor">g</div>
            </div>
          </div>
        </div>
      </div>

      <div className="wizardLabelAdvance">
        <div className="wizardDropdownStep3 allergens">Allergens</div>
        <ul className="allergens-content">
          {allergenData.map((val, index) => {
            const isSelected = allergen.some(
              (data: any) => data?.id === val?.id
            );
            return (
              <li key={index}>
                <input
                  type="checkbox"
                  checked={isSelected || allergenSelected.includes(val?.id)}
                  disabled={isSelected && !allergenSelected.includes(val?.id)}
                  onChange={(e) => handleCheckboxChange(e, val)}
                  className="checkboxIngredient"
                />
                <label>{val?.name}</label>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="wizardDropdownStep3">
        <div className=" wizardLabelAdvance allergens">Additional Info</div>
        <ul className="allergens-content">
          {attributes.map((val, index) => {
            return (
              <li key={index}>
                <input
                  type="checkbox"
                  onChange={(e) => handleaddionalinfocheck(e, val)}
                  className="checkboxIngredient"
                  checked={
                    addinfo.filter(
                      (data: additionalInfo) => data?.id === val?.id
                    ).length
                      ? true
                      : false
                  }
                />
                <label className="addtionalAttributeLabel">
                  {val?.attribute_name}
                </label>
              </li>
            );
          })}
        </ul>
      </div>
      {component == 'R&D Sub Recipe' ? null : (
        <div className="wizardDropdownStep3 stepThreeTextArea">
          <div className="PracticeLabel">
            Serving <span className="sterik">*</span>
          </div>
          <Input
            placeholder="Enter serving"
            defaultValue={serving || 1}
            type="text"
            onChange={(e) => {
              const value = e.target.value;
              // Allow only positive integers
              if (value === '' || /^\d+$/.test(value)) {
                const numValue = value === '' ? 1 : parseInt(value);
                if (numValue > 0) {
                  handleserving(value);
                }
              }
            }}
            style={{ width: '100%' }}
          />
          {/* {errorStatus && (
          <div className="subRecipeErrorMessages">
            {errorList['recipe_type_id'][0]}
          </div>
        )} */}
        </div>
      )}
    </>
  );
};

export default StepThree;
